import { z } from 'zod';

import { sharedStructuredEventShape } from './shared';

export const PRESENT_REASONING_TOOL_ID = 'presentReasoning';

export const presentReasoningPayloadSchema = z.object({
    label: z.string().optional(),
    text: z.string(),
});

export type PresentReasoningPayload = z.infer<typeof presentReasoningPayloadSchema>;

export const reasoningResponseEventSchema = z.object({
    ...sharedStructuredEventShape,
    payload: presentReasoningPayloadSchema,
    toolId: z.literal(PRESENT_REASONING_TOOL_ID),
});

export type ReasoningResponseEvent = z.infer<typeof reasoningResponseEventSchema>;
